import {CountiesPopulation} from "./counties-population";
import {CountiesArea} from "./counties-size";
import {PixarFilms} from "./pixar-films";
import {McuFilms} from "./mcu-films";

const parseDatalist = (data, descending) => {
    const lines = data.trim().split("\n");
    return lines.filter(Boolean).map(line => {
        const cols = line.split(",").map(s => s.trim());
        return {
            name: cols[0],
            displayValue: cols[1],
            rawValue: parseFloat(cols[2])
        };
    }).sort((a, b) => descending ? b.rawValue - a.rawValue : a.rawValue - b.rawValue);
}

export const Categories = [
    {
        "name": "English Counties by Population",
        "description": "The population of each ceremonial county at the 2021 census. Most populated to least populated.",
        "entries": parseDatalist(CountiesPopulation, true),
    },
    {
        "name": "English Counties by Area",
        "description": "The size of each ceremonial county. Largest to smallest.",
        "entries": parseDatalist(CountiesArea, true),
    },
    {
        "name": "Pixar Films by Release Date",
        "description": "Oldest to newest.",
        "entries": parseDatalist(PixarFilms, false),
    },
    {
        "name": "MCU Films by Release Date",
        "description": "Oldest to newest.",
        "entries": parseDatalist(McuFilms, false),
    },
];